import script from "./kalio-tel-input.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-tel-input.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__